import {
  Chip,
  IconChevronDown,
  List,
  NaviIconSearch,
  TodayChip,
} from '@banhala/ui-kit';
import { StyleSheet } from 'react-native';
import type { FilterListChip } from '../chipListGenerator';
import { ResetChip } from './ResetChip';
import { useFilterBottomSheet } from './useFilterBottomSheet';
import { useFilterListAtom } from '../Provider/filterList/useFilterListAtom';
import { useLogClickFilter } from '../hooks/useLogClickFilter';
import type { AnyObject } from '../../../../../types';

type ChipsListProps = {
  filterChips: Array<FilterListChip>;
  showResetChip: boolean;
  isSearchBarOpen: boolean;
  toggleSearchBar: VoidFunction;
  logging: AnyObject;
  scrollToFilterList: VoidFunction;
  closeSearchBar: VoidFunction;
  radioQueryName?: string;
};

export const HorizontalChipList = ({
  filterChips,
  showResetChip,
  isSearchBarOpen,
  toggleSearchBar,
  closeSearchBar,
  logging,
  scrollToFilterList,
  radioQueryName,
}: ChipsListProps) => {
  const { setToggleFilterChip } = useFilterListAtom();
  const { show: showFilterDrawer } = useFilterBottomSheet();
  const logClickFilter = useLogClickFilter(logging);

  const handleChangeFilter = (chip: FilterListChip) => {
    if (chip.type !== 'search') {
      logClickFilter({ selectedItem: chip.loggingText });
    }

    switch (chip.type) {
      case 'select':
        showFilterDrawer({
          filterToken: chip.filterToken,
          scrollToFilterList,
          radioQueryName,
        });
        return;
      case 'search':
        toggleSearchBar();
        return;
      case 'toggle':
        scrollToFilterList();
        setToggleFilterChip({
          queryName: chip.queryName,
          queryValue: chip.queryValue,
          isSelected: chip.value,
        });
        return;
      default:
        return;
    }
  };

  const renderItem = ({ item }: { item: FilterListChip }) => {
    const { text, type, value } = item;
    const isTodayChip = type === 'toggle' && text === '오늘출발';
    if (type === 'search') {
      return (
        <Chip
          size="medium"
          state={isSearchBarOpen ? 'selected' : 'enabled'}
          leftIcon={<NaviIconSearch />}
          onPress={() => {
            handleChangeFilter(item);
          }}
        >
          {text}
        </Chip>
      );
    }
    if (type === 'select') {
      return (
        <Chip
          size="medium"
          state={value ? 'selected' : 'enabled'}
          rightIcon={<IconChevronDown />}
          onPress={() => {
            handleChangeFilter(item);
          }}
        >
          {text}
        </Chip>
      );
    }
    if (isTodayChip) {
      return (
        <TodayChip
          state={value ? 'selected' : 'enabled'}
          onPress={() => {
            handleChangeFilter(item);
          }}
        />
      );
    }
    return (
      <Chip
        size="medium"
        state={value ? 'selected' : 'enabled'}
        onPress={() => {
          handleChangeFilter(item);
        }}
      >
        {text}
      </Chip>
    );
  };

  return (
    <List
      key={`filter-list-${filterChips.length}`}
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={style.contentContainerStyle}
      horizontal
      data={filterChips}
      ListHeaderComponent={
        showResetChip ? (
          <ResetChip
            closeSearchBar={closeSearchBar}
            logging={logging}
            radioQueryName={radioQueryName}
          />
        ) : undefined
      }
      renderItem={renderItem}
    />
  );
};

const style = StyleSheet.create({
  contentContainerStyle: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    gap: 8,
  },
});
